import styled from "styled-components";

export const StyledHeader = styled.header`
	display: flex;
	flex-direction: column;
	align-items: center;
`;
